import { useAtomValue } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  pathKey,
  type ScrollHash,
} from '~/apps/ninesegsAnalyzer/utils/customerAnalysis'
import {
  useSurveyQueryActiveBrandGroup,
  useSurveyQueryData,
  useSurveyQuerySurveyFilterTextGroups,
} from '~/hooks/useSurveyQuery'
import {
  assertExists,
  dataDisplayTypeLabelI18nKeyMap,
  type FigureInfo,
  segmentDisplayTypeLabelI18nKeyMap,
} from '~/utils'

import { dataDisplayTypeAtom, segmentDisplayTypeAtom } from '../atoms'

export const useFigureInfo = (figureType: ScrollHash): FigureInfo => {
  const { t } = useTranslation()
  const survey = useSurveyQueryData()
  const brandGroup = useSurveyQueryActiveBrandGroup()

  const dataDisplayType = useAtomValue(dataDisplayTypeAtom)
  const segmentDisplayType = useAtomValue(segmentDisplayTypeAtom)

  const surveyFilterTextGroups = useSurveyQuerySurveyFilterTextGroups()

  return React.useMemo(() => {
    assertExists(survey, t('assertion_failed'))
    const brandAccountId = survey.brandAccountId

    return {
      brandAccountId,
      brandGroup: brandGroup?.name,
      dataDisplayType: dataDisplayTypeLabelI18nKeyMap[dataDisplayType],
      figureType,
      pathKey,
      segmentDisplayType: segmentDisplayTypeLabelI18nKeyMap[segmentDisplayType],
      survey: survey.title,
      surveyFilter: surveyFilterTextGroups,
    }
  }, [
    brandGroup?.name,
    dataDisplayType,
    figureType,
    segmentDisplayType,
    survey,
    surveyFilterTextGroups,
    t,
  ])
}
